import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/talpool/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={770}
              height={549}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#EB2961" }}>Solution</span>
            </h2>
            <p>
              Our strategy for Talpool was to create a stunning, customized web
              design that speaks to client’s creative and artistic users, keep
              the user journey simple and intuitive, and to include features and
              functions that help users effectively connect and engage with each
              other.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
